import React, { Component } from 'react';

import './styles.css';

export default class ModalASN extends Component {
    constructor(props) {
        super(props)
        this.state = {
            purchaseOrderNumber: '',
            suffix: '',
            itemId: '',
            qty: '',
        }
    }

    onClose = e => {
        if(this.state.purchaseOrderNumber !== '' || this.state.suffix !== '' || this.state.itemId !== '' || this.state.qty !== '') {
            this.props.onData(true);
        } else {
            this.props.onClose && this.props.onClose(e);
        }
    };

    closeModal = e => {
        this.props.onClose && this.props.onClose(e);
    }

    handlePONumberChange = (event) => {
        const value = event.target.value;
        this.setState({purchaseOrderNumber: value});
    }

    handleSuffixChange = (event) => {
        const value = event.target.value;
        this.setState({suffix: value});
    }

    handleItemChange = (event) => {
        const value = event.target.value;
        this.setState({itemId: value});
    }

    handleQtyChange =(event) =>{
        const value = event.target.value;
        this.setState({qty: value});
    }

    sendASN = () => {
        this.props.openNotification(true);
        this.props.dataASN(this.state);
        this.closeModal();
    }

    cleanState = () => {
        this.setState({purchaseOrderNumber: '', itemId: '', qty: '', suffix: ''});
    }


    render() {
        if(!this.props.show) {
            if(this.state.purchaseOrderNumber !== '' || this.state.suffix !== '' || this.state.itemId !== '' || this.state.qty !== '') {
               this.cleanState();
            }
            return null;
        }
        return (
            <div className="modal-background">
                <div className="modal-container">
                    <div className="modal-form">
                        <h2 className="modal-title">Add Override ASN</h2>
                        <div className="modal-inputs-container">
                            <label htmlFor="item-number" className="modal-label">PO Number</label>
                            <input type="number" id="item-number" name="poNumber" className="input-modal" value={this.state.purchaseOrderNumber} onChange={this.handlePONumberChange}/>
                        </div>
                        <div className="modal-inputs-container">
                            <label htmlFor="vendor-number" className="modal-label">Suffix</label>
                            <input type="number" id="vendor-number" name="suffix" className="input-modal"  value={this.state.suffix} onChange={this.handleSuffixChange}/>
                        </div>
                        <div className="modal-inputs-container">
                            <label htmlFor="nipo-cost" className="modal-label">Item</label>
                            <input type="number" id="nipo-cost" name="item" className="input-modal"  value={this.state.itemId} onChange={this.handleItemChange}/>
                        </div>
                        <div className="modal-inputs-container">
                            <label htmlFor="order-pack" className="modal-label order-pack-label">Quantity</label>
                            <input type="number" id="order-pack" name="qty" className="input-modal"  value={this.state.qty} onChange={this.handleQtyChange}/>
                        </div>
                    </div>
                    <button type="button" className="btn btn-warning modal-return btn-sm" onClick={e => {this.onClose(e)}}>Return</button>
                    <button type="button" className="btn btn-warning btn-sm" onClick={this.sendASN}>Add</button>
                </div>
            </div>
            

        );
    }

}